import { render, staticRenderFns } from "./news21.vue?vue&type=template&id=51606c6a&"
import script from "./news21.vue?vue&type=script&lang=js&"
export * from "./news21.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports